export default {
  currentLanguage(state) {
    return state.language;
  },
  availableLocales(state) {
    return state.availableLocales;
  }
};
